import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { PageFilter } from '@common/paged-data/types/page-filter.type';
import { Page } from '@common/paged-data/types/page.type';
import { ApiService } from '@portal-core/auth/services/api.service';
import { TranslationPackageLanguageBranch } from '@portal-core/translation-package-language-branches/models/translation-package-language-branch.model';
import { TranslationPackageStatus } from '@portal-core/translation-packages/enums/translation-package-status.enum';
import { SharePendingRequest } from '@portal-core/util/observables.decorators';
import { Observable } from 'rxjs';

@Service()
export class TranslationPackageLanguageBranchesApiService {
  private readonly http = inject(HttpClient);
  private readonly apiService = inject(ApiService);

  uploadPackage$(file: File, translationPackageId: number): Observable<void> {
    const formData = new FormData();
    formData.append('File', file);
    return this.http.post<void>(`${this.apiService.centralApiBaseUri}/api/TranslationPackageLanguageBranch/${translationPackageId}/uploadPackage`, formData);
  }

  @SharePendingRequest()
  getProjectTranslationPackageLanguageBranches$(projectId: number, filter: PageFilter): Observable<Page<TranslationPackageLanguageBranch>> {
    return this.http.post<Page<TranslationPackageLanguageBranch>>(`${this.apiService.centralApiBaseUri}/api/TranslationPackageLanguageBranch/${projectId}/getProjectLanguageBranches`, filter);
  }

  deleteLanguageBranches$(translationPackageLanguageBranchIds: number[]): Observable<void> {
    return this.http.post<void>(`${this.apiService.centralApiBaseUri}/api/TranslationPackageLanguageBranch/bulkDelete`, translationPackageLanguageBranchIds);
  }

  updatePackageLanguageStatuses$(translationPackageLanguageBranchIds: number[], status: TranslationPackageStatus): Observable<void> {
    return this.http.put<void>(`${this.apiService.centralApiBaseUri}/api/TranslationPackageLanguageBranch/status/${status}`, translationPackageLanguageBranchIds);
  }
}
